import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
} from '@mui/material';
import EditorControls from '../../../BaseEditor/editorControls';
import { metaFieldPropType } from '../hooks';
import ChoicesTable from './choices';

const DIGITAL_CTYPES = ['Integer', 'Decimal'];
function MetaFieldProps({
  value, onChange, readOnly, allowedCtypes, allowedFields, allowedFonts, displayAllowedMetaFields,
}) {
  const choicesUsed = !!value.choices;
  const onChangeChoicesUsed = useCallback(
    () => {
      if (choicesUsed) onChange({ choices: null });
      else onChange({ choices: [['А', 'Варіант А']] });
    },
    [choicesUsed, onChange],
  );
  return (
    <div className="containerField p-3 border rounded">
      <EditorControls.StringInput
        controlId="metafield_label_input"
        label="Label"
        required
        description="Пользовательское название сущности"
        value={value.label}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ label: v })}
      />
      <EditorControls.Multiselector
        controlId="metafield_include_input"
        label="Include"
        required
        description="Перечень полей (из раздела fields) которые включает данная сущность. При использовании данного поля в запрос будут включены все поля из include."
        value={value.include}
        values={allowedFields}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ include: v })}
      />
      <EditorControls.Selector
        controlId="metafield_key_input"
        label="Key"
        description="Поле, используемое для сравнения значений. Например для отбора или для вычисления условного оформления ."
        value={value.key}
        values={allowedFields}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ key: v })}
      />
      <EditorControls.Selector
        controlId="metafield_ordered_input"
        label="Ordered"
        description="Поле, используемое для сортировки"
        value={value.ordered}
        values={allowedFields}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ ordered: v })}
      />
      <EditorControls.StringInput
        controlId="metafield_display_input"
        label="Display"
        required
        description="Является django- шаблоном для формирования представления значения."
        value={value.display}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ display: v })}
      />
      <EditorControls.Selector
        controlId="metafield_ctype_input"
        label="Ctype"
        description="Тип сущности"
        value={value.ctype}
        values={allowedCtypes}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ ctype: v, negative_red: false })}
      />
      <EditorControls.StringInput
        controlId="metafield_resource_input"
        label="Resource"
        required
        description="Url для описания типа внутренней сущности системы. Например '/api/references/refkbp7/'"
        value={value.resource}
        readOnly={readOnly || value.ctype !== 'NestedObject'}
        onChange={(e, v) => onChange({ resource: v })}
      />
      <EditorControls.CheckboxInput
        controlId="metafield_negative_red_input"
        description="Выделять отрицательные значения красным цветом"
        label="Отрицательное красным"
        value={value.negative_red}
        onChange={(e, v) => onChange({ negative_red: v })}
        disabled={readOnly || !DIGITAL_CTYPES.includes(value.ctype)}
      />
      <EditorControls.FormatInput
        controlId="metafield_format_input"
        label="Оформление поля"
        value={value.format}
        onChange={(v) => onChange({ format: { ...value.format, ...v } })}
        allowedFonts={allowedFonts}
        readOnly={readOnly}
        onReset={() => onChange({ format: null })}
      />
      <EditorControls.Selector
        controlId="metafield_setParent_input"
        label="Parent"
        description="Поле, используемое для выбора родителя"
        value={value.parent}
        values={displayAllowedMetaFields}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ parent: v })}
      />
      <Box>
        <EditorControls.CheckboxInput
          label="Використовувати список вибору"
          value={choicesUsed}
          onChange={onChangeChoicesUsed}
        />
        {choicesUsed && (
          <ChoicesTable
            value={value.choices}
            onChange={(e, v) => onChange({ choices: v })}
            ctype={value.ctype}
          />
        )}

      </Box>

    </div>
  );
}

MetaFieldProps.propTypes = {
  value: metaFieldPropType.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  allowedCtypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  allowedFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  allowedFonts: PropTypes.arrayOf(PropTypes.string),
  displayAllowedMetaFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

MetaFieldProps.defaultProps = {
  readOnly: false,
  allowedFonts: [],
};

export default MetaFieldProps;
